<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <create-search></create-search>
    </div>
  </div>
</template>

<script>
import CreateSearch from "../../components/CreateSearch.vue";

export default {
  components: {
    CreateSearch
  },
  name: "Search",
  data() {
    return {
      items: [],
      categorey: []
    };
  },
  methods: {},
  mounted() {},
  created() {}
};
</script>
<style></style>
